import { createContext, useState } from "react";

export const LayoutContext = createContext<{
    isMenuExpanded: boolean;
    toggleMenu: () => void;
    closeMenu: () => void;
    setMenuBackToSavedState: () => void;
    isRenamingBreadcrumb: boolean;
    setIsRenamingBreadcrumb: (isRenaming: boolean) => void;
}>(null as any);

interface LayoutProviderProps {
    children: React.ReactNode;
}
export const LayoutProvider = ({ children }: LayoutProviderProps) => {
    const [isMenuExpanded, setIsMenuExpanded] = useState(localStorage.getItem("navExpanded") !== "false");
    const [isRenamingBreadcrumb, setIsRenamingBreadcrumb] = useState(false);

    const toggleMenu = () => {
        setIsMenuExpanded(!isMenuExpanded);
        localStorage.setItem("navExpanded", (!isMenuExpanded).toString());
    };

    const closeMenu = () => {
        setIsMenuExpanded(false);
    };

    const setMenuBackToSavedState = () => {
        setIsMenuExpanded(localStorage.getItem("navExpanded") !== "false");
    };

    return (
        <LayoutContext.Provider
            value={{
                isMenuExpanded,
                toggleMenu,
                closeMenu,
                setMenuBackToSavedState,
                isRenamingBreadcrumb,
                setIsRenamingBreadcrumb,
            }}
        >
            {children}
        </LayoutContext.Provider>
    );
};
